import { render, staticRenderFns } from "./MenuFiltersBar.vue?vue&type=template&id=156548de&scoped=true"
import script from "./MenuFiltersBar.vue?vue&type=script&lang=js"
export * from "./MenuFiltersBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156548de",
  null
  
)

export default component.exports